import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const ImageDialog = ({ show, image, text, handleClose }) => {
    if (!show) return null;

    const { t } = useTranslation();

    return (
        <div className={`modal ${show ? 'show' : ''}`} tabIndex="-1" role="dialog" style={{ display: show ? 'block' : 'none' }}>
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Photo selected </h5>
                        {/* <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleClose} >
                            <span aria-hidden="true">&times;</span>
                        </button> */}
                    </div>
                    <div className="modal-body">     
                        { !text ? <img src={image} alt="Large photo" className="img-fluid" />
                            : <div className="container">
                                <div className="row align-items-start">
                                    <img src={image} alt="Large photo" class="col-12 col-sm-8" />
                                    <div class="col-12 col-sm-4"  >
                                        <span className="explain-text"> {text} </span>
                                    </div>
                                </div>
                            </div>
                        }  
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => handleClose(true)}>Close </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ImageDialog;